import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const CreditCard = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="Credit card icon"
    className={`shrink-0 h-${size} w-${size} ${className}`}
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={`color-iconBrand-default ${pathClass}`}
      d="M11 42.5C11 43.3284 11.6716 44 12.5 44H27.5C28.3284 44 29 43.3284 29 42.5V42.5C29 41.6716 28.3284 41 27.5 41H12.5C11.6716 41 11 41.6716 11 42.5V42.5Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      d="M5 32H59V29H5V32Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      d="M5 23H59V20H5V23Z"
    />
    <path
      className={`color-iconPrimary-disabled ${pathClass}`}
      d="M5 29V23H59V29H5Z"
    />
    <path
      className={`color-iconBrand-default ${pathClass}`}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52 13H12C8.13401 13 5 16.134 5 20V44C5 47.866 8.13401 51 12 51H52C55.866 51 59 47.866 59 44V20C59 16.134 55.866 13 52 13ZM12 10C6.47715 10 2 14.4772 2 20V44C2 49.5228 6.47715 54 12 54H52C57.5228 54 62 49.5228 62 44V20C62 14.4772 57.5228 10 52 10H12Z"
    />
  </svg>
)
